import React from 'react';

function PickUpCenterInformation(props) {
  const serviceCenterName = props.store.pickupServiceCenter.service_center_name;
  return (
    <div className='pickup-center-info'>
      <div className='pickup-info-header'>
        {props.isOrderSummary ? (
          <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='12' cy='12.5' r='9.5' fill='var(--theme-light,#e2cff7)' stroke='var(--theme-primary, #810ea9)' />
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M13.96 8.197c0-.937-.759-1.697-1.696-1.697a1.705 1.705 0 0 0-1.698 1.697 1.697 1.697 0 0 0 3.395 0zm.566 8.55a.486.486 0 0 1-.486.486h-3.554a.486.486 0 0 1-.486-.486v-.957c0-.268.218-.486.486-.486h.486v-2.581h-.486a.486.486 0 0 1-.486-.486v-.957c0-.268.218-.486.486-.486h2.574c.268 0 .486.218.486.486v4.032h.486c.268 0 .486.218.486.486l.008.949z'
              fill='var(--theme-primary, #810ea9)'
            />
          </svg>
        ) : (
          <svg width='120' height='121' viewBox='0 0 120 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M55.827 40.1c0 18.333 16.667 22.916 25 22.916v37.498c0 2.083-29.167 8.333-37.5 8.333-6.667 0-11.111-2.777-12.5-4.166-1.389-5.556-5.39-19.479-8.333-31.25-4.167-16.667 12.5-14.584 20.833-14.584 0-5.555.417-17.498 2.083-20.831 6.25-6.25 8.334-4.167 10.417 2.083z'
              fill='#E0C1FF'
            />
            <path
              d='M51.174 110.924H37.585c-5.62.002-10.452-4.007-11.523-9.56l-5.036-18.31c-4.48-12.793-2.53-19.6-.1-23.06a10.094 10.094 0 0 1 8.467-4.41h11.134a44.53 44.53 0 0 1 .465-13.88c2.707-10.899 8.636-11.375 11.052-11.076 3.78.469 7.222 3.784 7.222 6.955a21.083 21.083 0 0 0 5.544 15.624c5.64 5.677 15.819 7.197 15.92 7.212a2.827 2.827 0 0 1 2.387 3.201 2.815 2.815 0 0 1-3.18 2.402c-.494-.07-12.151-1.816-19.103-8.812a26.566 26.566 0 0 1-7.19-19.474 3.302 3.302 0 0 0-2.657-1.505c-1.796.073-3.493 2.633-4.54 6.847-1.433 5.771.031 14.78.046 14.871.136.821-.094 1.66-.629 2.295-.534.635-1.319 1-2.145 1H29.393a4.5 4.5 0 0 0-3.875 2.017c-1.1 1.567-3.22 6.457.842 17.999.022.063.042.126.06.19l5.093 18.517c.022.083.041.165.056.247.53 2.926 3.062 5.051 6.016 5.05h13.59c10.346 0 24.152-2.319 27.14-5.422a2.799 2.799 0 0 1 3.976-.062 2.843 2.843 0 0 1 .062 4.001c-5.616 5.831-24.875 7.143-31.179 7.143z'
              fill='var(--theme-primary, #810ea9)'
            />
            <path
              d='M98.86 110.558H80.33a2.82 2.82 0 0 1-2.812-2.83V59.553a2.82 2.82 0 0 1 2.812-2.83H98.86a2.821 2.821 0 0 1 2.812 2.83v48.175a2.821 2.821 0 0 1-2.812 2.83z'
              fill='var(--theme-primary, #810ea9)'
            />
            <path
              d='M83.144 104.882H96.05V62.367H83.144v42.515zM50.741 24.584a2.82 2.82 0 0 1-2.811-2.83v-8.002a2.82 2.82 0 0 1 2.811-2.83 2.82 2.82 0 0 1 2.812 2.83v8.002a2.82 2.82 0 0 1-2.812 2.83zM65.236 32.862a2.814 2.814 0 0 1-2.711-2.072 2.838 2.838 0 0 1 1.259-3.183l6.813-4.126a2.796 2.796 0 0 1 2.837-.084 2.833 2.833 0 0 1 1.464 2.448 2.834 2.834 0 0 1-1.402 2.485l-6.812 4.126a2.789 2.789 0 0 1-1.448.406zM36.264 32.853c-.51 0-1.01-.14-1.447-.405l-6.813-4.126a2.84 2.84 0 0 1-.921-3.861 2.801 2.801 0 0 1 3.82-.988l6.814 4.126a2.838 2.838 0 0 1 1.258 3.184 2.814 2.814 0 0 1-2.71 2.071z'
              fill='var(--theme-primary, #810ea9)'
            />
          </svg>
        )}

        {!props.isOrderSummary ? (
          <div className='idf-title-extra-bold justify-content-center d-flex'>{`${serviceCenterName} נבחר בהצלחה!`}</div>
        ) : (
          <div className='idf-title-marketing-regular justify-content-center d-flex'>לפני ההגעה למרכז שירות כדאי לדעת</div>
        )}
      </div>
      <div className='pickup-info-main'>
        <ul className='main-list'>
          <li className='list-item'>יש לבצע גיבוי למכשיר בטרם הגעה לאתר החלוקה</li>
          <li className='list-item'>באתר החלוקה תוכלו לקבל סיוע בהעברת אנשי הקשר למכשירכם החדש.</li>
          <li className='list-item'>לצורך קבלת החדש יש להגיע עם תעודת החוגר / קצין / נגד / אע״צ כתעודה מזהה.</li>
          <li className='list-item'>במידה והאיסוף יבוצע ע״י אדם אחר מטעמכם עליו להצטייד ביפויי כח.</li>
          <li className='list-item'>לאחר קבלת המכשיר נשלח לך הודעת sms להפעלת הקו החדש</li>
        </ul>
      </div>
    </div>
  );
}

export default PickUpCenterInformation;
